"use strict";
export class SubgraphRequestError extends Error {
  context;
  constructor(message, context) {
    super(message);
    this.name = "SubgraphRequestError";
    this.context = context;
  }
}
export async function fetchFromSubgraph(endpoint, options) {
  const { query, variables, operationName, signal, fetchImpl, requestId } = options;
  const requestBody = JSON.stringify({
    query,
    variables,
    operationName
  });
  const headers = {
    "Content-Type": "application/json",
    ...endpoint.headers ?? {}
  };
  const execFetch = fetchImpl ?? fetch;
  const response = await execFetch(endpoint.url, {
    method: "POST",
    headers,
    body: requestBody,
    signal
  });
  let payload = null;
  try {
    payload = await response.json();
  } catch (error) {
    throw new SubgraphRequestError(`Subgraph response was not valid JSON${requestId ? ` [${requestId}]` : ""}`, {
      status: response.status,
      statusText: response.statusText,
      url: endpoint.url
    });
  }
  if (!response.ok) {
    throw new SubgraphRequestError(
      `Subgraph request failed with status ${response.status}${requestId ? ` [${requestId}]` : ""}`,
      {
        status: response.status,
        statusText: response.statusText,
        url: endpoint.url,
        body: payload
      }
    );
  }
  if (payload?.errors?.length) {
    const messages = payload.errors.map((error) => error?.message ?? "Unknown error").join(", ");
    throw new SubgraphRequestError(
      `Subgraph returned errors: ${messages}${requestId ? ` [${requestId}]` : ""}`,
      {
        status: response.status,
        statusText: response.statusText,
        url: endpoint.url,
        body: payload
      }
    );
  }
  return payload?.data;
}
